<template>
  <div class="form-others">
    <edit-table
      :option="option"
      :data="ccData"
      :showHistory="true"
      @submit-add="handleSubmit"
      @submit-edit="handleSubmit"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
      @history-change="historyChange"
    />
    <a-drawer
      v-if="openHistory"
      :width="800"
      :title="i18n('history')"
      placement="right"
      :visible="openHistory"
      @close="() => (this.openHistory = false)"
      ><BTable
        :bordered="true"
        striped
        :items="equipmentHistory"
        :fields="fields"
      >
      </BTable>
    </a-drawer>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import WORKER from '@/api/worker/others'
import { deepClone } from '@/util/util'
import { BTable } from 'bootstrap-vue'
import moment from 'moment'
export default {
  components: {
    EditTable,
    BTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      othersData: [],
      openHistory: false,
      equipmentHistory: [],
    }
  },
  computed: {
    option() {
      const option = {
        addBtn: false,
        delBtn: false,
        historyBtn: true,
        editBtn: !(this.detailType === 'view'),
        columns: [
          {
            label: this.i18n('equipmentName'),
            field: 'equipmentName',
            class: 'table-td',
            disabled: true,
          },
          {
            label: this.i18n('equipmentSize'),
            field: 'equipmentSize',
            class: 'table-td',
          },
          {
            label: this.i18n('equipmentNumber'),
            field: 'equipmentQuantity',
            class: 'table-td',
          },
          {
            label: this.i18n('lastTime'),
            field: 'provideTime',
            class: 'table-td',
            disabled: true,
          },
        ],
      }
      return option
    },
    fields() {
      return [
        {
          label: this.i18n('equipmentName'),
          key: 'equipmentName',
          sortable: false,
        },
        {
          label: this.i18n('equipmentSize'),
          key: 'equipmentSize',
          sortable: false,
        },
        {
          label: this.i18n('equipmentNumber'),
          key: 'equipmentQuantity',
          sortable: false,
        },
        {
          label: this.i18n('releaseTime'),
          key: 'provideTime',
          sortable: false,
        },
        {
          label: this.i18n('uploadTime'),
          key: 'uploadTime',
          sortable: false,
        },
      ]
    },
    ccData() {
      const data = this.othersData
      return data.map((e) => {
        return {
          ...e,
          provideTime: e.provideTime
            ? moment(e.provideTime).format('YYYY-MM-DD')
            : '-',
        }
      })
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_worker.sarary.${param}`)
    },
    filterEmpty(e, type) {
      if (e) {
        if (type === 'date') {
          return moment(e).format('YYYY-MM-DD')
          // return e.toLocaleString()
        } else if (type === 'number') {
          return e < 0 ? '-' : e
        }
        return e
      }
      return '-'
    },
    handleSubmit(done, row) {
      console.log(row)
      const params = deepClone(row)
      const { columns } = this.option
      // const items =
      //   columns &&
      //   columns.reduce((v, c) => {
      //     const vv = v
      //     vv[c.field] = params[c.field]
      //     return v
      //   }, {})
      const items = {
        workerId: this.currentId,
        equipmentCategory: row.equipmentCategory,
        equipmentSize: params.equipmentSize,
        equipmentQuantity: params.equipmentQuantity,
      }

      WORKER.add({
        ...items,
      })
        .then((res) => {
          done()
          this.reLoad().then(() => {
            done()
          })
        })
        .catch(() => {
          done()
        })
    },
    handleRowDel(done, row) {
      console.log(row, 'handleRowDel')
    },
    historyChange(row) {
      // console.log(row)
      WORKER.getCategoryHistory({
        workerId: this.currentId,
        equipmentCategory: row?.item?.equipmentCategory,
      }).then((res) => {
        console.log(res, 'history')
        const data = res.data || {}
        if (data.code === 200) {
          this.equipmentHistory = data.data.map((e) => {
            return {
              equipmentName: this.filterEmpty(e.equipmentName),
              equipmentSize: this.filterEmpty(e.equipmentSize),
              equipmentQuantity: this.filterEmpty(
                e.equipmentQuantity,
                'number'
              ),
              provideTime: this.filterEmpty(e.provideTime, 'date'),
              uploadTime: this.filterEmpty(e.uploadTime, 'date'),
            }
          })
          this.openHistory = true
        }
      })
    },
    reLoad() {
      return new Promise((resolve) => {
        WORKER.getLatest({ workerId: this.currentId }).then((res) => {
          console.log(res.data.data, 'data+++')
          this.othersData = res.data.data
          resolve()
        })
      })
    },
    onLoad() {
      this.othersData = deepClone(this.data)
    },
    refreshChange() {
      this.reLoad()
    },
  },
}
</script>
<style lang="scss">
.form-others {
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    &-sm {
      width: 200px;
    }
  }
}
</style>
